import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { BrandLogoProvider } from "@/contexts/BrandLogoContext";
import { CartProvider } from "@/contexts/CartContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import CariList from "@/pages/CariList";
import CariDetail from "@/pages/CariDetail";
import StokList from "@/pages/StokList";
import StokHareketleri from "@/pages/StokHareketleri";
import SiparislerAdmin from "@/pages/SiparislerAdmin";
import AdminSepet from "@/pages/AdminSepet";
import ExcelImport from "@/pages/ExcelImport";
import KullaniciYonetimi from "@/pages/KullaniciYonetimi";
import Ayarlar from "@/pages/Ayarlar";
import Raporlar from "@/pages/Raporlar";
import Faturalar from "@/pages/Faturalar";
import MarjKontrolu from "@/pages/MarjKontrolu";
import AdminCatalogLinks from "@/pages/AdminCatalogLinks";
import B2BLayout from "@/pages/b2b/B2BLayout";
import B2BDashboard from "@/pages/b2b/B2BDashboard";
import B2BStok from "@/pages/b2b/B2BStok";
import B2BSepet from "@/pages/b2b/B2BSepet";
import B2BEkstre from "@/pages/b2b/B2BEkstre";
import B2BAldiklarim from "@/pages/b2b/B2BAldiklarim";
import B2BSiparisler from "@/pages/b2b/B2BSiparisler";
import B2BSiparisDetay from "@/pages/b2b/B2BSiparisDetay";
import B2BSonAramalar from "@/pages/b2b/B2BSonAramalar";
import "@/App.css";

const ADMIN_ROLES = ["admin", "satis_destek", "muhasebe", "depo"];

function App() {
  return (
    <AuthProvider>
      <BrandLogoProvider>
        <CartProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              path="/"
              element={
                <ProtectedRoute roles={ADMIN_ROLES}>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="cariler" element={<CariList />} />
              <Route path="cariler/:id" element={<CariDetail />} />
              <Route path="stoklar" element={<StokList />} />
              <Route path="arac-oem-baglantilari" element={<ProtectedRoute roles={["admin", "satis_destek"]}><AdminCatalogLinks /></ProtectedRoute>} />
              <Route path="stok-hareketleri" element={<StokHareketleri />} />
              <Route path="siparisler" element={<SiparislerAdmin />} />
              <Route path="sepet" element={<ProtectedRoute roles={["admin", "satis_destek"]}><AdminSepet /></ProtectedRoute>} />
              <Route path="excel-import" element={<ExcelImport />} />
              <Route path="kullanici-yonetimi" element={<KullaniciYonetimi />} />
              <Route path="ayarlar" element={<Ayarlar />} />
              <Route path="raporlar" element={<Raporlar />} />
              <Route path="faturalar" element={<Faturalar />} />
              <Route path="marj-kontrolu" element={<ProtectedRoute roles={["admin"]}><MarjKontrolu /></ProtectedRoute>} />
            </Route>

            <Route
              path="/b2b"
              element={
                <ProtectedRoute roles={["b2b_musteri"]}>
                  <B2BLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/b2b/anasayfa" replace />} />
              <Route path="anasayfa" element={<B2BDashboard />} />
              <Route path="stok" element={<B2BStok />} />
              <Route path="sepet" element={<B2BSepet />} />
              <Route path="ekstre" element={<B2BEkstre />} />
              <Route path="aldiklarim" element={<B2BAldiklarim />} />
              <Route path="siparisler" element={<B2BSiparisler />} />
              <Route path="siparisler/:siparisId" element={<B2BSiparisDetay />} />
              <Route path="son-aramalar" element={<B2BSonAramalar />} />
            </Route>

            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
        </CartProvider>
      </BrandLogoProvider>
    </AuthProvider>
  );
}

export default App;
